import React from 'react';
import { Helmet } from 'react-helmet-async';

const defaultTitle = 'Natalia Saenz - Selección y Liderazgo';
const defaultDescription = 'Servicios de selección, liderazgo y gestión de equipos. Coaching, formación y soluciones de Recursos Humanos para pymes.';
const defaultUrl = 'https://tudominio.com';
// If you add a WebP version at src/assets/img/header.webp the components will prefer it
const defaultImage = defaultUrl + '/assets/img/header.jpg';

export default function Seo({ title, description, url, image }) {
  const t = title || defaultTitle;
  const d = description || defaultDescription;
  const u = url || defaultUrl;
  const i = image || defaultImage;

  return (
    <Helmet>
      <title>{t}</title>
      <meta name="description" content={d} />
      <link rel="canonical" href={u} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:url" content={u} />
      <meta property="og:image" content={i} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t} />
      <meta name="twitter:description" content={d} />
      <meta name="twitter:image" content={i} />

      <script type="application/ld+json">{`{
        "@context": "https://schema.org",
        "@type": "Person",
        "name": "Natalia Saenz",
        "url": "${u}",
        "image": "${i}",
        "jobTitle": "Consultora en Selección y Liderazgo",
        "description": "${d}"
      }`}</script>
    </Helmet>
  );
}
